var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { cleanWhite, jetBlack } from '../../../colors';
var Wrapper = styled.button.withConfig({
  displayName: "hamburger__Wrapper",
  componentId: "sc-1chrmwa-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: block;\n  width: 2.8rem;\n  height: 1.4rem;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n\n  body.using-mouse &:active,\n  body.using-mouse &:focus {\n    outline: none;\n  }\n"], ["\n  position: relative;\n  display: block;\n  width: 2.8rem;\n  height: 1.4rem;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n\n  body.using-mouse &:active,\n  body.using-mouse &:focus {\n    outline: none;\n  }\n"])));
var StyledHamburger = styled.span.withConfig({
  displayName: "hamburger__StyledHamburger",
  componentId: "sc-1chrmwa-1"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n\n  &,\n  &:before,\n  &:after {\n    height: 2px;\n    width: 2.8rem;\n    background-color: ", ";\n    border-radius: 1px;\n    display: inline-block;\n  }\n\n  &:before,\n  &:after {\n    content: \"\";\n    position: absolute;\n    right: 0;\n    transition: all 0.2s;\n  }\n\n  &:before { top: -0.8rem; }\n\n  &:after { top: 0.8rem; }\n\n\n  ", "\n"], ["\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n\n  &,\n  &:before,\n  &:after {\n    height: 2px;\n    width: 2.8rem;\n    background-color: ", ";\n    border-radius: 1px;\n    display: inline-block;\n  }\n\n  &:before,\n  &:after {\n    content: \"\";\n    position: absolute;\n    right: 0;\n    transition: all 0.2s;\n  }\n\n  &:before { top: -0.8rem; }\n\n  &:after { top: 0.8rem; }\n\n\n  ", "\n"])), function (pr) {
  return pr.isMenuOpen ? cleanWhite() : jetBlack();
}, function (pr) {
  return pr.isMenuOpen && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    & {\n      background-color: transparent;\n    }\n\n    &:before,\n    &:after {\n      top: 0;\n      width: 3.2rem;\n    }\n    &:before {\n      transform: rotate(135deg);\n    }\n\n    &:after {\n      transform: rotate(-135deg);\n    }\n  "], ["\n    & {\n      background-color: transparent;\n    }\n\n    &:before,\n    &:after {\n      top: 0;\n      width: 3.2rem;\n    }\n    &:before {\n      transform: rotate(135deg);\n    }\n\n    &:after {\n      transform: rotate(-135deg);\n    }\n  "])));
});

var Hamburger = function Hamburger(_a) {
  var className = _a.className,
      onClick = _a.onClick,
      isMenuOpen = _a.isMenuOpen;
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className,
    onClick: onClick,
    "data-test": 'header-mobile-hamburger'
  }, /*#__PURE__*/React.createElement(StyledHamburger, {
    isMenuOpen: isMenuOpen
  }));
};

export default Hamburger;
var templateObject_1, templateObject_2, templateObject_3;